import { render, staticRenderFns } from "./SearchOfHospital.vue?vue&type=template&id=62e928f4&scoped=true&"
import script from "./SearchOfHospital.vue?vue&type=script&lang=js&"
export * from "./SearchOfHospital.vue?vue&type=script&lang=js&"
import style0 from "./SearchOfHospital.vue?vue&type=style&index=0&id=62e928f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e928f4",
  null
  
)

export default component.exports